export enum AccessType {
  ADMIN = "ADMIN",
  READ = "READ",
  READ_WRITE = "READ_WRITE",
  WRITE = "WRITE",
}
